/*  Copyright (C) 2025, 2026 Paul B. Lucas  ALL RIGHTS RESERVED   
    Licensed to University of Illinois   */
//
//  This composable supports a single function commonly called from multiple page views.  The function checks the 
//  use's claims groups for the specific groups used by this application and sets property Booleans in 
//  the Vuex store.  Also sets the the user roles array.
//
//          Membership in this groups           ===>            Sets this user property
//          2025 LoanAgreementManager-Admin                         is-sys-admin
//
//  Description:
//          Claims object is passed in as argument.  Groups are extracted from claim.  The configuration file 
//          AdminGroups.config.json is loaded and the id's for the groups extracted on basis of display name.
//          Groups on claims (array of group ids) are tested for the specific ids.. If the id is set,
//          the state.user object is mutated via the setSysAdmin() and other store actions.
//
//          
//  Changes:
//
//      02/25/2025      pblucas     Modified from RWA composable
//      03/06/2025      pblucas     Added support for three additional security groups
//                                  receivers, auditors, and IT support
//      03/16/2026      pblucas     Corrected typos & updated copyright
//

import AdminGroups        from '@/configuration/adminGroups.config.json'
import { store }          from '@/store/store'
  
const usePermissionsAPI = () => {
 
    const checkAdminGroups = (claims) =>  {

        const setSysAdmin       =   (v)  => store.dispatch('setSysAdmin', v)
        const setDeptAdmin      =   (v)  => store.dispatch('setDeptAdmin', v)
        const setITSupport      =   (v)  => store.dispatch('setITSupport', v)
        const setReceiver       =   (v)  => store.dispatch('setReceiver', v)
        const setAuditor        =   (v)  => store.dispatch('setAuditor', v)
 
        if(!claims.hasOwnProperty('groups'))    { 
            // user's claims has no groups property - not a member of admin groups
            // explicitly set memberships to false
            setSysAdmin(false)
            setDeptAdmin(false)
        }
        else {
            let securityGroups = claims.groups

            // determine the id of special groups by name from json specifier
            let sysAdminId = AdminGroups.securityGroups.find ((gp) => {
                if(gp.role == 'System_Admin') return gp;
            }).id
            let deptAdminId = AdminGroups.securityGroups.find ((gp) => {
                if(gp.role == 'Dept_Admin') return gp;
            }).id
            let ITSupportId = AdminGroups.securityGroups.find ((gp) => {
                if(gp.role == 'ITSupport') return gp;
            }).id
            let receiverId = AdminGroups.securityGroups.find ((gp) => {
                if(gp.role == 'Receiver') return gp;
            }).id
            let auditorId = AdminGroups.securityGroups.find ((gp) => {
                if(gp.role == 'Auditor') return gp;
            }).id
             // check to see user is in any of these groups
            let memberSystemAuthGroup   =   securityGroups.includes(sysAdminId)
            let memberDeptAuthGroup     =   securityGroups.includes(deptAdminId)
            let memberITSupportGroup    =   securityGroups.includes(ITSupportId)
            let memberAuditorGroup      =   securityGroups.includes(auditorId)
            let memberReceiverGroup     =   securityGroups.includes(receiverId)
            
            if (memberSystemAuthGroup)    setSysAdmin(true)   
            if (memberDeptAuthGroup)      setDeptAdmin(true)
            if (memberITSupportGroup)     setITSupport(true)
            if (memberAuditorGroup)       setAuditor(true)
            if (memberReceiverGroup)      setReceiver(true)

        }
              
    }
    
    return {checkAdminGroups}
}
export default usePermissionsAPI